import { apiFetch } from '../utils/api';

/**
 * Fetch autocomplete/search suggestions from the backend.
 * @param {string} query - The search string
 * @returns {Promise<Object>} Object containing products, categories, sections, popularSearches
 */
export const getSearchSuggestions = async (query, signal) => {
  const url = `/api/search?q=${encodeURIComponent(query)}`;
  const response = await apiFetch(url, { signal });
  if (!response.ok) {
    throw new Error(`Failed to fetch suggestions: ${response.statusText}`);
  }
  return response.json();
};
